export const readProductListing = (categoryId: string) => `/store-api/product-listing/${categoryId}`;
export const readProduct = () => `/store-api/product`;
export const readProductDetail = (productId: string) => `/store-api/product/${productId}`;
export const readProductCrossSelling = (productId: string) => `/store-api/product/${productId}/cross-selling`;
export const readProductStream = (steamId: string) => `/store-api/product-stream/${steamId}`;
